module.exports = __webpack_public_path__ + "static/media/Vista_satelital_de_America_del_Sur.132935cf.jpg";